import { Box, Button, Typography } from '@mui/material';
import { theme } from 'config/theme';
import useUserData from 'hooks/useUserData';
import UserAddLineIcon from 'remixicon-react/UserAddLineIcon';
import useInviteUserModalStore from 'store/useInviteUserModalStore';

type CircularHighlightProps = {
  label: string;
  count: number;
  icon: JSX.Element;
  message: string;
  onClick: () => void;
};

function CircularHighlight({ label, message, count = 0, icon, onClick }: CircularHighlightProps) {
  const openInviteUserModal = useInviteUserModalStore((state) => state.openModal);
  const { canInviteOthers } = useUserData();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: theme.palette.custom.tuna,
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 14 }}>{label}</Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: 100, lg: 120 },
          height: { xs: 100, lg: 120 },
          borderRadius: '50%',
          border: `5px solid ${theme.palette.custom.line}`,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={onClick}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 22 }}>{count}</Typography>
          <Typography sx={{ color: theme.palette.custom.mistBlue, fontSize: 12 }}>
            {message}
          </Typography>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bottom: -18,
            background: 'white',
            borderRadius: '50%',
            padding: 1,
          }}
        >
          {icon}
        </Box>
      </Box>
      {label === 'Members' && canInviteOthers && (
        <Button
          variant="text"
          size="small"
          startIcon={<UserAddLineIcon size={18} />}
          sx={(theme) => ({ minWidth: 'fit-content', color: theme.palette.custom.link, mt: 1.5 })}
          onClick={() => openInviteUserModal({ open: true })}
        >
          Invite
        </Button>
      )}
    </Box>
  );
}

export default CircularHighlight;
